import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConsoleHomeService } from 'src/app/core/services/console-home.service';

interface SlideFeature {
  icon?: string;
  iconClass?: string;
  title: string;
  description: string;
  numbered?: boolean;
}

interface Slide {
  tag: string;
  title: string;
  description: string;
  image: string;
  layoutType: 'type-1' | 'type-2' | 'type-3';
  features: SlideFeature[];
}

@Component({
  selector: 'vcp-whats-new-in-platform',
  templateUrl: './whats-new-in-platform.component.html',
  styleUrls: ['./whats-new-in-platform.component.scss'],
})
export class WhatsNewInPlatformComponent implements OnInit {
  step = 1;
  maxStep = 2;

  slides: Slide[] = [
    {
      tag: 'AI Assistant',
      title: 'Meet Your Vahana AI Chatbot',
      description:
        'Introducing the <strong>Vahana AI Chatbot</strong>, now available in your app header. Get instant answers, guidance, and support for anything related to the Vahana platform—right when you need it.',
      image: './assets/images/slide-overlay-01.png',
      layoutType: 'type-1',
      features: [
        {
          icon: './assets/images/commit-blue.svg',
          title: 'Instant Platform Guidance',
          description:
            'Ask questions about Vahana features, capabilities, and best practices to get immediate, context-aware answers.',
        },
        {
          icon: './assets/images/commit-green.svg',
          title: '24/7 Availability',
          description:
            'Access help anytime, directly from the header—no need to search through documentation or wait for support.',
        },
        {
          icon: './assets/images/commit-orange.svg',
          title: 'Context-Aware Assistance',
          description:
            'Get relevant suggestions and solutions based on your current work and the Vahana platform capabilities.',
        },
        {
          icon: './assets/images/commit-purple.svg',
          title: 'Learn as You Build',
          description:
            'Discover new features, learn shortcuts, and improve your productivity with intelligent recommendations tailored to your workflow.',
        },
      ],
    },
    {
      tag: 'Feedback System',
      title: 'Share Your Feedback Directly from the Header',
      description:
        'We value your input! Our new <strong>Feedback System</strong> is now integrated into the header, making it easier than ever to share your honest and valuable feedback across all modules of the platform.',
      image: './assets/images/slide-overlay-02.png',
      layoutType: 'type-1',
      features: [
        {
          icon: './assets/images/commit-blue.svg',
          title: 'One-Click Access',
          description:
            'Submit feedback instantly from the header—no need to navigate away from your current work.',
        },
        {
          icon: './assets/images/commit-green.svg',
          title: 'Module-Specific Feedback',
          description:
            'Provide targeted feedback for specific modules, helping us improve exactly where it matters most.',
        },
        {
          icon: './assets/images/commit-orange.svg',
          title: 'Always Accessible',
          description:
            'The feedback option is always available in the header, so you can share your thoughts whenever inspiration strikes.',
        },
        {
          icon: './assets/images/commit-purple.svg',
          title: 'Shape the Future',
          description:
            'Your honest feedback directly influences platform improvements and new feature development.',
        },
      ],
    },
  ];

  constructor(
    private chs: ConsoleHomeService,
    private dialogRef: MatDialogRef<WhatsNewInPlatformComponent>,
  ) {}

  ngOnInit(): void {}

  get currentSlide(): Slide {
    return this.slides[this.step - 1];
  }

  next() {
    this.step = this.step + 1;

    if (this.step > this.maxStep) {
      this.dialogRef.close();
      this.setPreferences();
    }
  }

  prev() {
    this.step = this.step - 1;
  }

  setPreferences() {
    const pref = [
      {
        name: 'ai_chat_shown',
        value: true,
      },
    ];

    this.chs.savePreference(pref).subscribe((res) => {});
  }
}
